import { FadeLoader } from "react-spinners";

const Spinner = () => {
    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="flex items-center justify-center border bg-white w-36 h-36 rounded-2xl border-gray5">
                <FadeLoader color="#4B632B" height={16} margin={6} radius={8} speedMultiplier={1} width={5} />
            </div>
        </div>
    );
};

export default Spinner;
